<template>
  <div class="counter-container">
    <div class="text">Счётчик аудитории</div>
    <div class="count">
      <span v-if="countAudience !== null && countAudience !== undefined">
        {{ formatNumber(countAudience) }}
      </span>
      <span v-else>—</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { formatNumber } from "@/services/utils/Strings";

const props = defineProps<{
  settedCount: number | null | undefined;
}>();

const emits = defineEmits(["updateAudienceCount"]);

const countAudience = ref<number | null | undefined>(props.settedCount);

watch(
  () => props.settedCount,
  (newValue) => {
    countAudience.value = newValue;
  }
);
</script>

<style lang="scss" scoped>
.counter-container {
  width: 240px;
  background-color: $main-link-color;
  border-radius: 16px;
  padding: 12px 21px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

  .text {
    line-height: 1rem;
    color: $main-light-color;
    margin-top: 14px;
  }

  .count {
    padding: 22px 0;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 2rem;
    font-style: normal;
    font-weight: 700;
    line-height: 135%;
    color: white;
    letter-spacing: 0.28px;
  }
}
</style>
